import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Lock, Unlock } from "lucide-react";
import { api, errMsg, money } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function BalanceRow({ item, kind, onChange }) {
  const [bal, setBal] = useState(String(item.balance));
  const [limit, setLimit] = useState(String(item.credit_limit ?? ""));
  const isCard = kind === "cards";

  const run = async (fn, msg) => {
    try { await fn(); toast.success(msg); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const save = () => run(() => api.patch(`/admin/${kind}/${item.id}`, { balance: parseFloat(bal), ...(isCard ? { credit_limit: parseFloat(limit) } : {}) }), "Balance updated");
  const lock = () => run(() => api.patch(`/admin/cards/${item.id}`, { locked: !item.locked }), item.locked ? "Card unlocked" : "Card locked");
  const del = () => window.confirm(`Remove ${item.name}?`) && run(() => api.delete(`/admin/${kind}/${item.id}`), "Removed");

  return (
    <div className="flex flex-wrap items-center gap-3 border rounded-lg px-4 py-3 bg-slate-50/60" data-testid={`admin-row-${item.id}`}>
      <div className="min-w-[200px] flex-1">
        <div className="font-semibold text-sm text-[var(--navy)]">{item.name} ...{item.number_last4}</div>
        <div className="text-xs text-slate-500">{isCard ? `Credit card${item.locked ? " · Locked" : ""}` : item.type} · now {money(item.balance)}</div>
      </div>
      <Input type="number" step="0.01" className="w-36 bg-white" value={bal} onChange={(e) => setBal(e.target.value)} data-testid={`admin-balance-input-${item.id}`} />
      {isCard && <Input type="number" step="0.01" className="w-32 bg-white" value={limit} onChange={(e) => setLimit(e.target.value)} placeholder="Limit" data-testid={`admin-limit-input-${item.id}`} />}
      <Button size="sm" onClick={save} className="bg-[var(--blue)] hover:bg-[var(--navy)]" data-testid={`admin-save-balance-${item.id}`}>Set</Button>
      {isCard && <button onClick={lock} className="text-slate-500 hover:text-[var(--red)]" data-testid={`admin-lock-card-${item.id}`}>{item.locked ? <Unlock size={16} /> : <Lock size={16} />}</button>}
      <button onClick={del} className="text-slate-400 hover:text-[var(--red)]" data-testid={`admin-delete-${item.id}`}><Trash2 size={16} /></button>
    </div>
  );
}
